<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="4">
                <el-text-field
                  label="Pranešimo pavadinimas (LT)"
                  v-model="mainData['text_lt-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Pranešimo pavadinimas (EN)"
                  v-model="mainData['text_en-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Kodas"
                  v-model="mainData['code-search-like']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="searchData(true)"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminErrorNotificationsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.searchData(true)
    },
  },
}
</script>
